module.exports = __webpack_public_path__ + "img/sphere12-graph-black.26df4623.png";